import { Button } from 'react-bootstrap';
import React from 'react';
import NavBar from '../../NavBar/NavBar';
import TextAnimation from 'react-animate-text';
import './Header.css';
import { useHistory } from 'react-router';
import Typical from 'react-typical'

const Home = () => {
    const history = useHistory();
    const resumeLink = 'https://drive.google.com/file/d/1TnDkU_T56h5J2vOH-9liSxe4ksxj5JkQ/view?usp=sharing';
    return (
        <section className="shadow-container">
            <NavBar />
            <div className="App-header header-background">
                <div className="container">
                    <TextAnimation charInterval="100">
                        <Typical
                            steps={['Hello', 1000, 'Hello world!', 500]}
                            loop={Infinity}
                            wrapper="p"
                        />
                        <h1 className="name-style">Call Me <span className="naim">Naim</span></h1>
                        <h5 className="transparent-text">A guy who cooks with html css js and makes new recipes</h5>
                    </TextAnimation>
                    <br />
                    <Button href={resumeLink} target="_blank" className="btn-border button-custom1" variant="light">HIRE ME</Button>
                    <Button onClick={() => history.push('/resume')} className="btn-border button-custom2" variant="outline-light">RESUME</Button>
                </div>
            </div>
        </section>
    );
};

export default Home;